export default __webpack_public_path__ + "static/media/Packs.d9885ebf.png";